import KnackApiWrapper from '@knack/api-wrapper';

export function getTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    return undefined;
  }
}

const knackApiWrapperSettings = {
  api_uri: process.env.VUE_APP_API_URL,
};

const Api = new KnackApiWrapper(knackApiWrapperSettings);
const timezone = getTimezone();
if (timezone) {
  Api.axios.defaults.headers['knack-client-timezone'] = timezone;
}

export default Api;
